import styled from 'styled-components'
import { theme } from '../theme/theme'
import { FC } from 'react'
import { Label } from './styles/Typography'

interface TagProps {
  text: string
  color?: string
}

export const Tag: FC<TagProps> = ({ text, color = theme.color.green }) => {
  return <TagLabel $color={color}>{text}</TagLabel>
}

const TagLabel = styled(Label)<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  color: ${theme.color.white};
  padding: 6px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  margin-left: auto;
`

export const OutlinedTag: FC<{ text: string }> = ({ text }) => {
  return <OutlinedTagLabel>{text}</OutlinedTagLabel>
}

const OutlinedTagLabel = styled.span`
  border: 1px solid ${theme.color.beigeDark};
  border-radius: ${theme.spacing.medium}px;
  padding: 3px 9px;
  font-size: ${theme.fontSize.xsmall}px;
  font-family: ${theme.font.body};
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.3px;
  color: ${theme.color.grey5};
`
